import React from 'react';
import chunk from 'lodash/chunk';
import { isEmpty } from 'lodash/fp';
import Button from '../Button/Button';
import Card from '../Card/Card';

const FeaturedNewsItem = ({ url, image, title }) => {
  return <Card href={url} imageUrl={image} overlayTitle={true} title={title} />;
};

const RegularNewsItem = ({ url, image, title }) => {
  return (
    <Card
      href={url}
      imageUrl={image}
      title={title}
      shadow={true}
      responsive={true}
      imageBorder={true}
    />
  );
};

const LatestNews = ({ latestNewsConfig, latestNewsItems }) => {
  const {
    title,
    tag,
    ctaLabel,
    ctaUrl,
    showCta,
    defaultImageUrl,
  } = latestNewsConfig;

  const chunkedNewsItems = chunk(latestNewsItems, 2);
  const featuredNewsItems = chunkedNewsItems[0];
  const regularNewsItems = chunkedNewsItems[1];

  if (isEmpty(latestNewsItems)) return null;

  return (
    <div className="latest-news container">
      <div className="latest-news__title">
        <div className="latest-news__title-text">{title}</div>
        {tag && <div className="tag">{tag}</div>}
      </div>
      <div className="latest-news__items">
        <div
          style={regularNewsItems === undefined ? { width: '100%' } : {}}
          className="latest-news__featured"
        >
          {featuredNewsItems &&
            featuredNewsItems.map((item, index) => (
              <FeaturedNewsItem
                key={`featured-news-${index}`}
                image={item.image ? item.image : defaultImageUrl}
                title={item.title}
                url={item.url}
              />
            ))}
        </div>
        {regularNewsItems && (
          <div className="latest-news__regular">
            {regularNewsItems.map((item, index) => (
              <RegularNewsItem
                key={`regular-news-${index}`}
                image={item.image ? item.image : defaultImageUrl}
                title={item.title}
                url={item.url}
              />
            ))}
          </div>
        )}
      </div>
      {showCta && (
        <div className="latest-news__cta">
          <Button className="btn btn--default" href={ctaUrl} text={ctaLabel} />
        </div>
      )}
    </div>
  );
};

export default LatestNews;
